export enum ManageUsersScreenUIState {
  CausableAdmins = 1,
  GameAdmins = 2,
  CrossGameAdmins = 3,
  CharityAdmins = 4
}
